import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import BlogTiptapEditor from "Partials/Blog/BlogList/Components/BlogTiptapEditor";

/**
 * Shared form for Add Page and Edit Page.
 */
const PageForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    title = "Page",
    submitLabel = "Save Page",
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>{title}</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                // ── Content rich text (Tiptap) ────────────────────────────────
                if (field.type === "textarea" && field.name === "content") {
                    return (
                        <div key={field.name} className={field.fieldSize || "col-12"}>
                            <label className="form-label">{field.label}</label>
                            <BlogTiptapEditor
                                valueHtml={values[field.name]}
                                onChangeHtml={(html) =>
                                    handleChange({
                                        target: { name: field.name, value: html },
                                    })
                                }
                            />
                            {errors[field.name] && (
                                <div className="text-danger mt-2">{errors[field.name]}</div>
                            )}
                        </div>
                    );
                }

                // ── Switch (publish status) ──────────────────────────────────
                if (field.type === "switch") {
                    return (
                        <Switch
                            key={field.name}
                            values={values[field.name]}
                            handleChange={handleChange}
                            field={field}
                            ValueOne="1"
                            ValueTwo="0"
                            LabelOne="Active"
                            LabelTwo="Inactive"
                        />
                    );
                }

                // ── Default text input ───────────────────────────────────────
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label={submitLabel}
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default PageForm;
